import request from '../utils/request'

/**
 * 订单相关接口
 */

// 创建订单
export function createOrder(data) {
  return request({
    url: '/h5/order/create',
    method: 'post',
    data
  })
}

// 从购物车创建订单
export function createOrderFromCart(data) {
  return request({
    url: '/h5/order/createFromCart',
    method: 'post',
    data
  })
}

// 积分兑换下单
export function createByPoints(data) {
  return request({
    url: '/h5/order/createByPoints',
    method: 'post',
    data
  })
}

// 获取订单列表
export function getOrderList(params) {
  return request({
    url: '/h5/order/list',
    method: 'get',
    params
  })
}

// 获取订单详情
export function getOrderDetail(orderId) {
  return request({
    url: `/h5/order/${orderId}`,
    method: 'get'
  })
}

// 取消订单
export function cancelOrder(orderId) {
  return request({
    url: `/h5/order/cancel/${orderId}`,
    method: 'post'
  })
}

// 模拟支付（临时）
export function mockPay(orderId) {
  return request({
    url: `/h5/order/pay/${orderId}`,
    method: 'post'
  })
}

// JSAPI 统一下单（公众号H5支付）
export function jsapiPay(orderId) {
  return request({
    url: `/h5/pay/jsapi/${orderId}`,
    method: 'post'
  })
}

// 查询支付状态
export function getPayStatus(orderId) {
  return request({
    url: `/h5/pay/status/${orderId}`,
    method: 'get'
  })
}

// 确认收货
export function confirmReceive(orderId) {
  return request({
    url: `/h5/order/confirm/${orderId}`,
    method: 'post'
  })
}

// 查询物流轨迹
export function getLogistics(orderId) {
  return request({
    url: `/h5/order/logistics/${orderId}`,
    method: 'get'
  })
}

// 获取收货地址列表（后续实现）
export function getAddressList() {
  return request({
    url: '/h5/address/list',
    method: 'get'
  })
}
